import { render, staticRenderFns } from "./AfRevenue.vue?vue&type=template&id=6c3a4acb&scoped=true"
import script from "./AfRevenue.vue?vue&type=script&lang=js"
export * from "./AfRevenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3a4acb",
  null
  
)

export default component.exports